module.exports = __webpack_public_path__ + "static/img/zzpzbzimg.bbc38a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zzpzbzimg.jpg
// module id = ZpdP
// module chunks = 1